<script setup>
import { AppIcon } from '@/components/shared'

/**
 * Inline error message paired with a form field. Renders nothing when
 * `message` is empty so a clean field stays uncluttered.
 *
 * `id` lets the sibling input target this element via aria-describedby
 * (the convention is `{input-id}-error`). `role="alert"` causes screen
 * readers to announce the message as soon as it appears, even if focus
 * is still on the input - critical for catching validation feedback
 * the user can't see (no-vision or low-vision).
 */
defineProps({
    id: {
        type: String,
        default: null,
    },
    message: {
        type: String,
        default: null,
    },
})
</script>

<template>
    <p
        class="text-error mt-2 flex items-center gap-1.5 text-xs font-medium"
        v-if="message"
        :id="id"
        role="alert"
    >
        <AppIcon
            class="text-sm"
            name="error"
        />
        {{ message }}
    </p>
</template>
